import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import parse from 'html-react-parser'
import Texteditor from "./Texteditor"
import axiosJWT from '../../JwtToken'

export const Edit = ({ rowID, getData, closeEdit, getPesan, setMsg }) => {

    const [potensialCode, setPotensialCode] = useState('')
    const [potensialName, setPotensialName] = useState('')
    const [end_date, setEndDate] = useState('')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [information, setInformation] = useState('')
    const [picName, setPicName] = useState('')
    const [picPhone, setPicPhone] = useState('')
    const [file, setFile] = useState("")
    const [preview, setPreview] = useState("")
    const [data, setData] = useState([])
    const [editorLoaded, setEditorLoaded] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        getKegiatan()
        getPotencial()
        setEditorLoaded(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getPotencial = async (key) => {
        try {
            const response = await axiosJWT.post("/api/kegiatan-usaha/publish", {
                key: key
            })
            setData(response.data)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Data tidak terkirim, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const getPotencialName = async (code) => {
        const response = await axiosJWT.post('/api/kegiatan-usaha/filter', {
            code,
            jml: 1
        })
        setPotensialCode(code)
        setPotensialName(response.data[0].name)
    }

    const getKegiatan = async () => {
        const response = await axiosJWT.get(`/api/procurement/${rowID}`)
        setPotensialCode(response.data.potensialCode)
        if (response.data.end_date) {
            const formattedDate = response.data.end_date.substring(0, 10); // Hasilnya pasti: YYYY-MM-DD
            setEndDate(formattedDate);
        }
        setTitle(response.data.title)
        setDescription(response.data.description)
        setInformation(response.data.information)
        setPicName(response.data.picName)
        setPicPhone(response.data.picPhone)
        setPreview(response.data.filePath)
    }

    const loadFile = (e) => {
        const file = e.target.files[0]
        setFile(file)
        setPreview(URL.createObjectURL(file))
    }

    const proses = async (e) => {
        e.preventDefault()

        if (file && file.size > 50 * 1024 * 1024) {
            setMsg('Ukuran file (Maksimal 50 MB)!')
            return
        }

        try {
            const formData = new FormData()
            formData.append("potensialCode", potensialCode)
            formData.append("potensialName", potensialName)
            formData.append("end_date", end_date)
            formData.append("title", title)
            formData.append("description", description)
            formData.append("picName", picName)
            formData.append("picPhone", picPhone)
            formData.append("file", file)

            const response = await axiosJWT.put(`/api/procurement/update/${rowID}`, formData)

            getPesan()
            setMsg(response.data.msg)

            setTimeout(() => {
                getPesan()
                setMsg('')
                getData('')
                closeEdit()
            }, 2000)

        } catch (err) {
            getPesan()
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Maaf, proses pengiriman data gagal!'
            setMsg(errorMsg)

            setTimeout(() => {
                getPesan()
                setMsg('')
            }, 4000)
        }
    }

    return (<>
        <form onSubmit={proses} className="form-horizontal">
            <h5 className="right-line color-success">Informasi Kebutuhan</h5>
            <div className="row">
                <div className="form-group col-md-6">
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label className="control-label">Kegiatan Usaha</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-filter"></i></span>
                                <select className="form-control" value={potensialCode} onChange={(e) => getPotencialName(e.target.value)} required>
                                    <option value="">==</option>
                                    {data.map((row, i) => (
                                        <option key={i} value={row.potensialCode}>{i + 1}. {row.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-group col-md-12">
                            <label className="control-label">Judul</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-newspaper-o"></i></span>
                                <input type="text" className="form-control" onChange={(e) => setTitle(e.target.value)} value={title} required />
                            </div>
                        </div>
                        <div className="form-group col-md-12">
                            <label className="control-label">Batas Waktu Pengadaan</label>
                            <div className="input-group">
                                <span className="input-group-addon"><i className="fa fa-calendar"></i></span>
                                <input type="date" className="form-control" onChange={(e) => setEndDate(e.target.value)} value={end_date} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">File</label>
                    {preview ? (<iframe width="100%" height="200" src={preview} title="Preview File" alt="Preview File" />) : (<img width="100%" height="200" src="/assets/img/no-image.png" title="Preview File" alt="Preview File" />)}
                    <input className="form-control" type="file" onChange={loadFile} />
                    <span className="badge d-inline-block text-wrap badge-danger">File Ekstensi .JPG | .JPEG | .PNG | .PDF | .MP4</span>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">PIC</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-user"></i></span>
                        <input type="picName" className="form-control" onChange={(e) => setPicName(e.target.value)} value={picName} required />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label className="control-label">No. Hp PIC</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-phone"></i></span>
                        <input type="number" className="form-control" onChange={(e) => setPicPhone(e.target.value)} value={picPhone} required />
                    </div>
                </div>
                <div className="form-group col-md-12">
                    <label className="control-label">Deskripsi</label>
                    <div className="input-group">
                        <span className="input-group-addon"><i className="fa fa-info"></i></span>
                        <Texteditor onChange={(description) => { setDescription(description) }} editorLoaded={editorLoaded} value={description || ''} required />
                    </div>
                </div>
            </div>
            {information && information.trim() !== '' && information !== 'undefined' ? (<>
                <h5 className="right-line color-success">Keterangan Status</h5>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label className="control-label">Keterangan</label>
                        <div className="input-group">
                            <span className="input-group-addon"><i className="fa fa-info"></i></span>
                            {parse(information)}
                        </div>
                    </div>
                </div>
            </>) : null}
            <div className="modal-footer">
                <button className="btn btn-raised btn-success br-2 no-m" type="Submit"><i className="fa fa-edit"></i> Update</button>
                <button onClick={closeEdit} className="btn btn btn-raised btn-danger br-2 no-m">
                    <i className="fa fa-sign-out"></i> Tutup
                </button>
            </div>
        </form>
    </>)
}